<template>
    <div class="row">
        <div class="col-lg-6">
            <div class="row mb-lg-0 mb-3 align-items-center">
                <input class="form-control col-2" v-bind:class="(errors !== null ? 'error-input' : '')" type="radio" value="person" name="user_type" id="user_type_person" v-bind:checked="modelValue == 'person'" @input="updateValue($event.target.value)">
                <label class="col pl-0 mb-0" for="user_type_person">
                    Osoba prywatna
                </label>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="row align-items-center">
                <input class="form-control col-2" v-bind:class="'form-control ' + (errors !== null ? 'error-input' : '')" type="radio" value="company" name="user_type" id="user_type_company" v-bind:checked="modelValue == 'company'" @input="updateValue($event.target.value)">
                <label class="col pl-0 mb-0" for="user_type_company">
                    Firma
                </label>
            </div>
        </div>
                    
        <div class="error" v-if="errors">
            <ul>
                <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: ['name', 'errorMessages', 'modelValue'],

    methods: {
        updateValue(value) {
            this.$emit('input', value);
            if(this.errorMessages && this.name in this.errorMessages) {
                this.value = value;
            }
        }
    },
    data() {
        return {
            value: ''
        };
    },
    computed: {
        errors: function () {
            if(this.errorMessages && this.name in this.errorMessages && this.value === '') {
                return this.errorMessages[this.name];
            }

            return null;
        }
    },
    watch: {
        errorMessages: function(newValue, oldValue) {
            this.value = '';
        }
    }
}
</script>
